import { render } from "./KullanicilarView.vue?vue&type=template&id=7df48474"
import script from "./KullanicilarView.vue?vue&type=script&lang=js"
export * from "./KullanicilarView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__